import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mapGetters, mapMutations } from 'vuex'
import PageHeaderWithActionBar from '@/components/common/Header/PageHeaderWithActionBar.vue'
import MainContainer from '../containers/MainContainer.vue'
import * as types from '@/store/types'
import * as accountTypes from '@account/store/types'
import gnbApi from '@gnb/api'
@Component({
    components: { PageHeaderWithActionBar, MainContainer },
    computed: {
        ...mapGetters({
            User: accountTypes.USER
        })
    },
    methods: {
        ...mapMutations({
            setCurrentMenu: types.CURRENT_MENU,
        })
    },
})
export default class MainView extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentMenu!: (name: string) => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    unreadAlarmCount: number = 0

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    menu(name: string) {
        this.setMenu(name)
    }

    getUnreadAlarm() {
        gnbApi.gnb.getWorkFeedUnreadCount(this.User.personCode, this.User.comCode).then((res: any) => {
            if (res > 0) {
                this.unreadAlarmCount = res
            }
        })
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.getUnreadAlarm()
    }
}
